import React from 'react';
import SvgIcon from './SvgIcon';

function VisibilityIcon({ width }) {
    return (
        <SvgIcon className="VisibilityIcon" width={width}>
            <svg
                width="100%"
                height="100%"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g id="icons/visibility">
                    <path
                        id="color"
                        d="M9.00168 11.6827C9.85156 11.6827 10.5734 11.3853 11.1671 10.7904C11.7609 10.1956 12.0577 9.47319 12.0577 8.62331C12.0577 7.77344 11.7603 7.05162 11.1654 6.45787C10.5706 5.86412 9.84818 5.56725 8.99831 5.56725C8.14843 5.56725 7.42662 5.86469 6.83287 6.45956C6.23912 7.05444 5.94225 7.77681 5.94225 8.62669C5.94225 9.47656 6.23968 10.1984 6.83456 10.7921C7.42943 11.3859 8.15181 11.6827 9.00168 11.6827ZM8.99999 10.65C8.43749 10.65 7.95937 10.4531 7.56562 10.0594C7.17187 9.66563 6.97499 9.1875 6.97499 8.625C6.97499 8.0625 7.17187 7.58438 7.56562 7.19063C7.95937 6.79688 8.43749 6.6 8.99999 6.6C9.5625 6.6 10.0406 6.79688 10.4344 7.19063C10.8281 7.58438 11.025 8.0625 11.025 8.625C11.025 9.1875 10.8281 9.66563 10.4344 10.0594C10.0406 10.4531 9.5625 10.65 8.99999 10.65ZM9.00093 13.875C7.27631 13.875 5.70487 13.3993 4.28662 12.4478C2.86837 11.4964 1.82412 10.2221 1.15387 8.625C1.82412 7.02788 2.86799 5.75362 4.28549 4.80225C5.70312 3.85075 7.27431 3.375 8.99906 3.375C10.7237 3.375 12.2951 3.85075 13.7134 4.80225C15.1316 5.75362 16.1759 7.02788 16.8461 8.625C16.1759 10.2221 15.132 11.4964 13.7145 12.4478C12.2969 13.3993 10.7257 13.875 9.00093 13.875ZM8.99999 12.75C10.4125 12.75 11.7094 12.3781 12.8906 11.6344C14.0719 10.8906 14.975 9.8875 15.6 8.625C14.975 7.3625 14.0719 6.35938 12.8906 5.61563C11.7094 4.87188 10.4125 4.5 8.99999 4.5C7.58749 4.5 6.29062 4.87188 5.10937 5.61563C3.92812 6.35938 3.02499 7.3625 2.39999 8.625C3.02499 9.8875 3.92812 10.8906 5.10937 11.6344C6.29062 12.3781 7.58749 12.75 8.99999 12.75Z"
                        fill="#333333"
                    />
                </g>
            </svg>
        </SvgIcon>
    );
}

export default VisibilityIcon;
